// eslint-disable import/default
import "whatwg-fetch";
import { serverURL } from "../helpers/url-helpers";

class BaseApi {
  constructor() {
    this.fetchOptions = {
      //Netanel 18/11/18 - add no cache headers to support all browsers inc ie11.
      headers: {
        // Accept: "application/json",
        // "Access-Control-Allow-Credentials": true,
        // "Content-Type": "application/json",
        // Cache: "no-store",
        // Pragma: "no-cache",
        // "Cache-Control": "no-store"
        //"X-XSRF-TOKEN": document.cookie
      },
      credentials: "same-origin" // same-origin / include
    };

    if (!process.env.NODE_ENV || process.env.NODE_ENV === "production") {
      this.fetchOptions.headers["Cache"] = "no-store";
      this.fetchOptions.headers["Cache-Control"] = "no-store";
      this.fetchOptions.headers["Pragma"] = "no-cache";
      // this.fetchOptions.headers["Access-Control-Allow-Credentials"] = true;
    }

    this.serverURL = serverURL;
    this.titles = {
      generalErrorTitle: "Something went really wrong",
      generalErrorMessage: "Failed to connect to the server"
    };
  }

  get = async (url, isFull = false) => {
    const fullUrl = !isFull ? this.serverURL + url : url;
    try {
      const response = await fetch(fullUrl, {
        method: "GET",
        ...this.fetchOptions
      });
      return await this.onSuccess(response);
    } catch (error) {
      const error = {
        friendlyTitle: this.titles.generalErrorTitle,
        friendlyMessage: this.titles.generalErrorMessage,
        fullError: error,
        target: fullUrl
      };
      return await this.onError(error);
    }
  };

  post = (url, data) => {
    const fullUrl = this.serverURL + url;
    const postOptions = {
      ...this.fetchOptions,
      headers: {
        "Content-Type": "application/json"
      }
    };
    return fetch(fullUrl, {
      method: "POST",
      body: JSON.stringify(data),
      ...postOptions
    }).then(this.onSuccess, this.onError);
  };

  put = (url, data) => {
    const fullUrl = this.serverURL + url;
    return fetch(fullUrl, {
      method: "PUT",
      body: JSON.stringify(data),
      ...this.fetchOptions
    }).then(this.onSuccess, this.onError);
  };

  onSuccess = async response => {
    return await response.json();
  };

  onError = async ({ fullError, friendlyTitle, friendlyMessage, target }) => {
    console.warn(fullError, target); // eslint-disable-line no-console
    return await Promise.resolve({
      error: true,
      title: friendlyTitle,
      message: friendlyMessage
    });
  };
}

export default new BaseApi();



// WEBPACK FOOTER //
// ./src/api/BaseApi.js